import { useAuth0 } from '@auth0/auth0-react'

export function Login() {
  const { loginWithRedirect } = useAuth0()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center">
            <img src="/logo.png" alt="FoosFi.re" className="h-20 w-auto" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            FoosFi.re
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Track your foosball games with Company Controlling rules
          </p>
        </div>
        <div>
          <button
            onClick={() => loginWithRedirect()}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Sign in to get started
          </button>
        </div>
      </div>
    </div>
  )
}
